import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	more: {
		id: 'search.common.icons.all-apps.more',
		defaultMessage: '+ more',
		description: 'Label to signify that a user can search for more connected apps',
	},
	moreWithCount: {
		id: 'search.common.icons.all-apps.more-with-count',
		defaultMessage: '+{appCount}',
		description: 'Label showing the number of additional apps a user can search across, e.g. "+5"',
	},
});
